module.exports = __webpack_public_path__ + "static/media/DBMock.899d7353.png";